(() => {
  const buttonSelector = '.productView-complementary .olitans-addon-button[data-btn-addtocart]';
  const formSelector = '.productView-complementary .olitans-addon-form';
  const pending = new WeakMap();

  const clearTimer = (button) => {
    const timer = pending.get(button);
    if (timer) window.clearTimeout(timer);
    pending.delete(button);
  };

  const resetButton = (button) => {
    button.classList.remove('is-added');
    button.removeAttribute('aria-live');
  };

  const markAdded = (button) => {
    if (!button || button.disabled) return;

    clearTimer(button);
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.setAttribute('aria-live', 'polite');

    pending.set(button, window.setTimeout(() => {
      resetButton(button);
      pending.delete(button);
    }, 1600));
  };

  const findButtonForVariant = (variantId) => {
    if (!variantId) return null;

    return Array.from(document.querySelectorAll(`${formSelector} input[name="id"]`))
      .find((input) => String(input.value) === String(variantId))
      ?.closest(formSelector)
      ?.querySelector(buttonSelector) || null;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);
    if (!button || button.disabled) return;

    clearTimer(button);
    button.classList.remove('is-added');
    button.classList.add('is-loading');

    pending.set(button, window.setTimeout(() => {
      if (button.classList.contains('is-loading')) {
        button.classList.remove('is-loading');
      }
      pending.delete(button);
    }, 3200));
  }, true);

  document.addEventListener('olitans:cart-success', (event) => {
    const button = findButtonForVariant(event.detail?.variantId);
    if (button) markAdded(button);
  });

  document.addEventListener('cart-update', (event) => {
    const button = findButtonForVariant(event.detail?.variantId);
    if (button) markAdded(button);
  });
})();
